// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3HGPs","error":"Textarea_error__1ycsK","readonly":"Textarea_readonly__3DyLK","disabled":"Textarea_disabled__1VdRH"};